
export type FlatNavEntry = {
  id: string;
  href: string;
  order: number;
};

export function flattenNavEntries(config: MainSidebarConfig): FlatNavEntry[] {
  const entries: FlatNavEntry[] = [];
  let order = 0;

  for (const section of config.sections) {
    for (const item of section.items) {
      if (item.href) {
        entries.push({ id: item.id, href: item.href, order: order++ });
      }
      if (item.children) {
        for (const child of item.children) {
          entries.push({ id: child.id, href: child.href, order: order++ });
        }
      }
    }
  }

  return entries;
}

export function isNavEntryActive(
  pathname: string,
  entryId: string,
  entryHref: string,
  allEntries: FlatNavEntry[]
): boolean {
  const matches = allEntries.filter(
    (entry) => pathname === entry.href || pathname.startsWith(`${entry.href}/`)
  );

  if (matches.length === 0) return false;

  const maxLength = Math.max(...matches.map((entry) => entry.href.length));
  const bestMatches = matches.filter((entry) => entry.href.length === maxLength);

  const winner = bestMatches.sort((a, b) => a.order - b.order)[0];
  return winner?.id === entryId;
}

export function isParentActive(
  pathname: string,
  item: NavItem,
  allEntries: FlatNavEntry[]
): boolean {
  if (!item.children?.length) return false;

  return item.children.some((child) =>
    isNavEntryActive(pathname, child.id, child.href, allEntries)
  );
}
